import { Cloud } from '@silbo/core';

export const getConfigQuery = (healthCenterId: string) => Cloud.getConfig({ healthCenterId });
